const IconSizes = {
  small: 16,
  regular: 20,
  large: 24,
};

const spacing = {
  x05: 4,
  x1: 8,
  x2: 16,
  x3: 24,
  x4: 32,
};

const borderRadius = {
  small: 4,
  regular: 8,
  large: 16,
};

export { borderRadius, IconSizes, spacing };

